/**
 *    SPDX-License-Identifier: Apache-2.0
 */

import reducer from './reducers';
import themeTypes from './types';
import * as themeSelectors from './selectors';
import * as themeActions from './actions';

export { themeTypes };
export { themeSelectors };
export { themeActions };

export default reducer;
